export const bonusSquareIndices = {
  doubleLetter: [
    3,
    11,
    36,
    38,
    45,
    52,
    59,
    92,
    96,
    98,
    102,
    108,
    116,
    122,
    126,
    128,
    132,
    165,
    172,
    179,
    186,
    188,
    213,
    221,
  ],
  doubleWord: [
    16,
    28,
    32,
    42,
    48,
    56,
    64,
    70,
    112,
    154,
    160,
    168,
    176,
    182,
    192,
    196,
    208,
  ],
  tripleLetter: [20, 24, 76, 80, 84, 88, 136, 140, 144, 148, 200, 204, 210],
  tripleWord: [0, 7, 14, 105, 119, 210, 217, 224]
};
